@if (status() === 'loading') {
  <div class="game-skeleton" aria-busy="true" aria-label="Cargando la sección del juego">
    <div class="game-skeleton__hero" aria-hidden="true"></div>

    <div class="game-page__body">
      <div class="game-skeleton__nav" aria-hidden="true">
        <span class="game-skeleton__line game-skeleton__line--logo"></span>
        @for (nav of skeletonParagraphs; track nav) {
          <span class="game-skeleton__line game-skeleton__line--nav"></span>
        }
      </div>

      <div class="game-page__content">
        <section class="game-page__section game-page__section--white">
          <div class="game-skeleton__intro" aria-hidden="true">
            <div class="game-skeleton__intro-copy">
              <span class="game-skeleton__line game-skeleton__line--heading"></span>
              @for (p of skeletonParagraphs; track p) {
                <span class="game-skeleton__line game-skeleton__line--body"></span>
              }
            </div>
            <span class="game-skeleton__media"></span>
          </div>
        </section>

        <section class="game-page__section game-page__section--alt">
          <span class="game-skeleton__line game-skeleton__line--heading" aria-hidden="true"></span>
          <div class="game-skeleton__product-grid" aria-hidden="true">
            @for (slot of skeletonProducts; track slot) {
              <div class="game-skeleton__product">
                <span class="game-skeleton__product-media"></span>
                <span class="game-skeleton__line game-skeleton__line--name"></span>
                <span class="game-skeleton__line game-skeleton__line--price"></span>
              </div>
            }
          </div>
        </section>
      </div>
    </div>
  </div>
} @else if (game(); as g) {
  <app-game-hero [game]="g" />

  <div class="game-page__body">
    <app-game-section-nav
      class="game-page__nav"
      [game]="g"
      [sections]="navSections()"
      [activeSection]="activeSection()"
      (sectionClick)="scrollToSection($event)"
    />

    <main class="game-page__content">
      @if (g.intro?.whatIs) {
        <section id="que-es" class="game-page__section game-page__section--white">
          <div class="game-page__section-inner">
            <app-game-intro [content]="g.intro!" [gameName]="g.name" mode="what-is" />
          </div>
        </section>
      }

      @if (g.intro?.howToPlay) {
        <section id="como-jugar" class="game-page__section game-page__section--white">
          <div class="game-page__section-inner">
            <app-game-intro [content]="g.intro!" [gameName]="g.name" mode="how-to-play" />
          </div>
        </section>
      }

      @if (g.starterGuide; as starterGuide) {
        <section id="por-donde-empezar" class="game-page__section game-page__section--alt">
          <div class="game-page__section-inner">
            <app-starter-guide
              [content]="starterGuide"
              [gameName]="g.name"
              [categorySlug]="g.categorySlug"
              (zoomOpen)="onZoomOpen($event)"
              (addToCart)="onAddToCart($event)"
              (notifyRequest)="onNotify($event)"
              (notifyCancel)="onNotifyCancel($event)"
              (cardClick)="onCardClick($event)"
              (reserveClick)="onReserve($event)"
            />
          </div>
        </section>
      }

      @if (g.community; as community) {
        <section id="comunidad" class="game-page__section game-page__section--white">
          <div class="game-page__section-inner">
            <app-game-community
              [content]="community"
              [gameName]="g.name"
              [gameSlug]="g.slug"
              [accentColor]="g.accentColor"
            />
          </div>
        </section>
      }

      @if (g.blogPosts.length > 0) {
        <section id="blog" class="game-page__section game-page__section--alt">
          <div class="game-page__section-inner">
            <app-game-blog-posts [posts]="g.blogPosts" [gameName]="g.name" />
          </div>
        </section>
      }
    </main>
  </div>

  @if (zoomProduct(); as product) {
    <app-product-zoom-modal
      [product]="product"
      [notifyActive]="zoomNotifyActive()"
      (close)="onZoomClose()"
      (addToCart)="onZoomAddToCart($event)"
      (reserveRequest)="onZoomReserve($event)"
      (notifyRequest)="onNotify($event)"
      (notifyCancel)="onNotifyCancel($event)"
      (viewDetails)="onZoomViewDetails($event)"
    />
  }
} @else {
  <div class="game-page__not-found">
    <p>{{ status() === 'error' ? copy.loadError : copy.notFound }}</p>
  </div>
}
